<template>
  <div>
    <div>
     <row>
      <col6></col6>
      <col6>
        <v-slider
          :label="$t('models_and_train_configs.confidence_treshold')"
          :hint="$t('models_and_train_configs.confidence_treshold_hint')"
          max="100"
          min="0"
          step="5"
          thumb-label
          :model-value="modelValue"
          @update:model-value="$emit('update:modelValue', $event)"
        ></v-slider>
      </col6>
    </row>
    </div>
  </div>
</template>

<script>
import Col6 from "@/components/layout/Col6";
import Row from "@/components/layout/Row";

export default {
  name: "TresholdSlider",
  components: {Col6, Row},
  props: {
    modelValue: {
      type: Number,
      default: 60,
    },
  },
  emits: ['update:modelValue'],
}
</script>

<style scoped>

</style>
